import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

import NewModal from 'components/Admin/Webinars/Views/New/Modal';

export default function Filters({ keyword, setKeyword }) {
  const [showNewModal, setShowNewModal] = useState(false);

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Search Webinar"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>

        <Col md={9} className="text-right">
          <Button
            onClick={() => setShowNewModal(true)}
            bsStyle="primary"
          >
            Add Webinar
          </Button>
        </Col>
      </Row>

      <NewModal show={showNewModal} onHide={() => setShowNewModal(false)} />
    </div>
  );
}

Filters.propTypes = {
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
};
